import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ToasterService {
  constructor(
    private toastr: ToastrService,
    private translateService: TranslateService
  ) { }

  showError(message: string) {
    setTimeout(() => this.toastr.error(message, null));
  }

  showErrorTranslating(message: string) {
    this.translateService.get(message)
      .subscribe(
        (translation: string) => this.showError(translation)
      );
  }

  showSuccess(message: string) {
    setTimeout(() => this.toastr.success(message, null));
  }

  showSuccessTranslating(message: string) {
    this.translateService.get(message)
      .subscribe(
        (translation: string) => this.showSuccess(translation)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/services/visual/toaster.service.ts